import { githubApi } from '@/api'

const actions = {
  link(context, token) {
    return githubApi.link(token)
  },

  token(context, { code }) {
    return githubApi.token(code)
  },

  check() {
    return githubApi.check()
  }
}

export default {
  actions
}
